<script lang="ts">
	import Vue from 'vue';
	import {Component} from 'vue-property-decorator';
	import {Permissions} from "@/helpers/constants";

	@Component
	export default class RightChecks extends Vue {

		public get rLoggedIn(): boolean {
			return this.$store.getters['user/isLoggedIn'];
		}


		public get rAdmin(): boolean {
			return this.$store.getters['user/hasPermission'](Permissions.rightAdmin);
		}

		public get rMasterData(): boolean {
			return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
		}

		public get rMetaData(): boolean {
			return this.$store.getters['user/hasPermission'](Permissions.rightMetaData);
		}

		public get rFinance(): boolean {
			return this.$store.getters['user/hasPermission'](Permissions.rightFinance);
		}


		public get rCustomerBusiness(): boolean {
			return this.$store.getters['user/hasPermission'](Permissions.rightCustomerBusiness);
		}

		public get rCustomerPrivate(): boolean {
			return this.$store.getters['user/hasPermission'](Permissions.rightCustomerPrivate);
		}


		public get rBackendUser(): boolean {
			return this.$store.getters['user/hasPermission'](Permissions.rightBackendUser);
		}

		public get rCustomerManager(): boolean {
			return this.$store.getters['user/hasPermission'](Permissions.rightCustomerManager);
		}

	}
</script>
